import { IntlShape } from "react-intl";

export const dateRangeOptions = (intl: IntlShape) => [
  {
    label: intl.formatMessage({ id: "report.ThisWeek", defaultMessage: "This week" }),
    value: "this_week",
  },
  {
    label: intl.formatMessage({ id: "report.lastWeek", defaultMessage: "Last week" }),
    value: "last_week",
  },
  {
    label: intl.formatMessage({ id: "report.ThisMonth", defaultMessage: "This month" }),
    value: "this_month",
  },
  {
    label: intl.formatMessage({ id: "report.lastMonth", defaultMessage: "Last month" }),
    value: "last_month",
  },
  {
    label: intl.formatMessage({ id: "report.YearToDate", defaultMessage: "Year to date" }),
    value: "year_to_date",
  },
  {
    label: intl.formatMessage({ id: "report.LastYear", defaultMessage: "Last year" }),
    value: "last_year",
  },
];

export const groupByOptions = (intl: IntlShape) => [
  {
    label: intl.formatMessage({ id: "report.RequestDate", defaultMessage: "Request date" }),
    value: "request_date",
  },
  {
    label: intl.formatMessage({ id: "report.BookDate", defaultMessage: "Book date" }),
    value: "book_date",
  },
  {
    label: intl.formatMessage({ id: "report.PickUpDate", defaultMessage: "Pick up date" }),
    value: "pickup_date",
  },
  {
    label: intl.formatMessage({ id: "report.DeliveryDate", defaultMessage: "Delivery date" }),
    value: "delivery_date",
  },
  {
    label: intl.formatMessage({ id: "report.ApprovedDate", defaultMessage: "Approved date" }),
    value: "invoice_approved_date",
  },
  {
    label: intl.formatMessage({ id: "report.InvoiceSubmitDate", defaultMessage: "Invoice submit date" }),
    value: "invoice_submit_date",
  },
];

export const shipmentOptions = (intl: IntlShape) => [
  {
    label: intl.formatMessage({ id: "report.RequestDate", defaultMessage: "Request date" }),
    value: "request_date",
  },
  {
    label: intl.formatMessage({ id: "report.BookDate", defaultMessage: "Book date" }),
    value: "book_date",
  },
  {
    label: intl.formatMessage({ id: "report.PickUpDate", defaultMessage: "Pick up date" }),
    value: "pickup_date",
  },
  {
    label: intl.formatMessage({ id: "report.DeliveryDate", defaultMessage: "Delivery date" }),
    value: "delivery_date",
  },
  {
    label: intl.formatMessage({ id: "report.ApprovedDate", defaultMessage: "Approved date" }),
    value: "invoice_approved_date",
  },
  {
    label: intl.formatMessage({ id: "report.InvoiceSubmitDate", defaultMessage: "Invoice submit date" }),
    value: "invoice_submit_date",
  },
];

export const reportShipmentOptions = (intl: IntlShape, co2_emission_enabled: Boolean) => [
  {
    label: intl.formatMessage({ id: "general.shipmentDetails", defaultMessage: "Shipment Details" }),
    value: "shipment_details",
  },
  {
    label: intl.formatMessage({ id: "report.booking", defaultMessage: "Booking" }),
    value: "booking",
  },
  {
    label: intl.formatMessage({ id: "report.customs", defaultMessage: "Customs" }),
    value: "customs",
  },
  ...(co2_emission_enabled
    ? [
        {
          label: intl.formatMessage({ id: "report.CO2Emission", defaultMessage: "CO2 Emission" }),
          value: "emission",
        },
      ]
    : []),
  {
    label: intl.formatMessage({ id: "report.financial", defaultMessage: "Financial" }),
    value: "financial",
  },
  {
    label: intl.formatMessage({ id: "general.goods", defaultMessage: "Goods" }),
    value: "goods",
  },
  {
    label: intl.formatMessage({ id: "report.requestedContainerTypes", defaultMessage: "Requested Container Types" }),
    value: "requested_container_types",
  },
  {
    label: intl.formatMessage({ id: "general.invoice", defaultMessage: "Invoice" }),
    value: "invoice",
  },
  {
    label: intl.formatMessage({
      id: "new-request.organisational-details.locationDetails",
      defaultMessage: "Location Details",
    }),
    value: "location_details",
  },
  {
    label: intl.formatMessage({ id: "invoices.organizationTableHeader", defaultMessage: "Organizational" }),
    value: "organizational",
  },
  {
    label: "POD",
    value: "pod",
  },
  {
    label: intl.formatMessage({ id: "report.quoting", defaultMessage: "quoting" }),
    value: "quoting",
  },
  {
    label: intl.formatMessage({
      id: "components.molecules.navigation.shipmentTracking",
      defaultMessage: "Shipment Tracking",
    }),
    value: "shipment_tracking",
  },
  {
    label: intl.formatMessage({ id: "report.shipmentTiming", defaultMessage: "Shipment Timing" }),
    value: "shipment_timing",
  },
];
